import { useEffect, useRef, useState } from 'react';

import { TUseTimerProps } from '../types';
import { tickTimer } from '../utils';

export const useTimer = ({ countTo, addingZeros, handlerEndTime }: TUseTimerProps) => {
    const timerId = useRef<number>();

    const [timeData, setTimeData] = useState(tickTimer({ countTo, addingZeros }));

    useEffect(() => () => window.clearTimeout(timerId.current), []);

    useEffect(() => {
        timerId.current = window.setTimeout(() => {
            if (!countTo || !timeData.restTime || timeData.restTime <= 0) {
                if (countTo && handlerEndTime) {
                    handlerEndTime();
                }

                return;
            }

            const data = tickTimer({ countTo, addingZeros });

            setTimeData(data);
        }, 1000);

        return () => window.clearTimeout(timerId.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeData, countTo]);

    return timeData;
};
